import React, { FC } from 'react';
import translate from '@translate';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TransportsSectionTopBlock from '../TransportsSection/TopBlock';

interface TopBlockProps {
    reloadList: () => void;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <TransportsSectionTopBlock
            actions={[
                {
                    onClick: props.reloadList,
                    icon: <ReloadIcon />,
                    tooltip: translate('palletTypes.action.reload'),
                    variant: 'outlined',
                    'data-testid': 'pallet-types-reload-btn',
                },
            ]}
        />
    );
};

export default TopBlock;
